$(window).load(function() {

  const mqTab = window.matchMedia( "(min-width: 1024px)" );
  const mqPhone = window.matchMedia( "(min-width: 768px)" );

  $(".tips-title").css("opacity", "1");

  //Categories
  $('.tips-cat').each(function() {
    $(this).click(function(e) {
      e.preventDefault();
      $('.tips-cat').removeClass('selected');
      $(this).addClass('selected');

      let section = $(this).data('section');
      let headerOffset = 120;
      if (!mqTab.matches) {
        headerOffset = 170;
      }

      $("html, body").animate({ scrollTop: $('#tips-'+section).offset().top - headerOffset}, "slow");
    });
  });

  //Commands
  //mobile
  $('.command-dropdown').on('change', function() {
    let section = $(this).val();

    $('.command-right').removeClass('selected');
    $('#command-' + section).addClass('selected');
  });

  //desktop
  $('.command-left .info-multi.command-multi').each(function() {
    $(this).click(function(e) {
      e.preventDefault();
      $('.command-left .info-multi.command-multi').removeClass('selected');
      $(this).addClass('selected');

      let section = $(this).data('section');

      $('.command-right').removeClass('selected');
      $('.command-' + section).addClass('selected');
    });
  });


  //Email form on mobile
  $('.joinText').on('click', function (e) {
    const mq3 = window.matchMedia( "(max-width: 769px)" );

    if (mq3.matches) {
      $(".joinText").css('top', '5%');
      $('#email_signup').css("display", "block");
    }
  });


  window.onscroll = function(e) {

    let yScrollPosition = window.scrollY;

    //fade out lines
    // $("img.lines-img").css('opacity', 90 / (yScrollPosition));

    //BACK TO TOP
    if ((window.innerHeight + window.scrollY) >= 800) {
      $('#backToTop').css("display", "block").css("opacity", "0.5");
    } else {
      $('#backToTop').css("opacity", "0").css("display", "none");
    }

    //FIXED MENU
    let sticky = $('.tips-cat-container.static').offset().top - 40;

    if (!mqTab.matches) {
      sticky = $('.tips-cat-container.static').offset().top - 40;
    }

    if (window.scrollY >= sticky) {
      $('.tips-cat-container.fixed-menu').removeClass('hidden');
    } else {
      $('.tips-cat-container.fixed-menu').addClass('hidden');
    }

    //menu highlight

    $('.fixed-menu .tips-cat').each(function() {
      let section = $(this);
      // capture the height of the menu
      let navHeight = 121;
      let sectionName = section.data('section');
      let scrollCont = document.getElementById('cat-inner');

      if (!mqTab.matches) {
        navHeight = 171;
      }

      let sectionCont = $('#tips-' + sectionName);

      // subtract the menu height from the top of the section
      if(sectionCont.position().top - navHeight  <= yScrollPosition && section.offset().top + section.height()> yScrollPosition) {
        $('.tips-cat').removeClass('selected');
        $('.tips-cat.' + sectionName).addClass('selected');

        //scroll on mobile
        let current = document.getElementsByClassName('tips-cat selected')[0];
        if (!mqPhone.matches) {
          current.scrollIntoView();
        }
      } else {
        $('.tips-cat.' + sectionName).removeClass('selected');
      }
    });

  };

  $('#backToTop').each(function() {
    $(this).click(function(e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  });
});
